// src/app/components/groups/groups.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { GroupsRoutingModule } from './groups-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';

import { ListGroupsComponent } from './list-groups/list-groups.component';
import { CreateGroupComponent } from './create-group/create-group.component';
import { GroupUserComponent } from './group-users/group-users.component';

// ng-zorro
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzTableModule } from 'ng-zorro-antd/table';

@NgModule({
  declarations: [ListGroupsComponent, CreateGroupComponent, GroupUserComponent],
  imports: [
    CommonModule,
    FormsModule,            // para [(ngModel)]
    ReactiveFormsModule,
    NgbModule,
    SharedModule,
    GroupsRoutingModule,

    // Zorro usados en la vista
    NzTreeSelectModule,
    NzTableModule
  ]
})
export class GroupsModule { }
